<template>
  <div>
    <!--
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    -->
    <div class="row">
      <div class="col-lg-12">
        <!-- 端口状态信息 -->
        <block-cntr
          :btitle="page.blkTitle.portStatisticsTable"
          style="height: 100%"
        >
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div @click="resetport" class="btn" style="padding: 0px">
                  <i class="fa fa-history page-tableaction" title="reset"></i>
                </div>
                <div @click="loadport" class="btn" style="padding: 0px">
                  <i class="fa fa-refresh page-tableaction" title="refresh"></i>
                </div>
              </div>
            </span>
          </div>
          <table
            class="table table-hover table-noneborder-top"
            style="overflow-x: auto"
          >
            <thead style="width: 2500px">
              <tr>
                <th
                  v-for="(value, key) in portStatisticsTable.brief"
                  :key="key"
                  :title="portStatisticsTable.title[key]"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 280px; width: 2500px">
              <tr v-for="row in portStatisticsTable.data" :key="row.port">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div
                    v-if="key === 'pstatus'"
                    class="fa fa-circle"
                    :style="{
                      color: row.pstatus === 'On' ? '#32CD32' : '#FF4500',
                    }"
                  ></div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "portStatistics",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.portstatistics,
      portStatisticsTable: "",
      iBox: {},
    }
  },
  created() {
    this.loadport()
  },
  methods: {
    loadport() {
      get("portstatistics")
        .then((res) => (this.portStatisticsTable = res.data))
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    resetport() {
      post("portstatistics")
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config Successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              res.data.code === 0 ? "Info" : "Warn",
              res.data.msg !== undefined ? res.data.msg : "Unknow error!"
            )
          setTimeout(() => {
            this.loadport()
          }, 2000)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>